<template>


  <div class="min-h-screen"> 

    <Header />

    <div class="w-full h-[7px] bg-gray-200">
      <div class="h-full bg-blues transition-all duration-300" :style="{ width: progressBarWidth }"></div>
    </div>


          <div class="flex gap-6 justify-end py-5 px-10">  
            <div @click="this.$router.go(-1)" class="">
              <div
                class="mb-1 cursor-pointer rounded-lg flex border justify-center w-24 gap-2 items-center py-1 bg-white"
              >
                <div class="text-sm text-gray-700 hover:text-teal-500" title="back">
                  back
                </div>
                <div class="flex items-center">
                  <img
                    src="https://img.icons8.com/external-simple-solid-edt.graphics/15/undefined/external-Back-arrows-simple-solid-edt.graphics-2.png"
                  />
                </div>
              </div>
            </div>
          </div>


    <div
      class="w-full lg:max-w-3xl 2xl:max-w-4xl mx-auto bg-gray-100 relative m-4 p-4 rounded-xl mt-20"
    >
      <form
        action=""
        @submit.prevent="NewCourse()"
        class="w-full lg:p-4 mx-auto"
      >
        <h1 class="text-left py-2 text-xl font-semibold text-gray-600">
          Course with AI
        </h1>
        <!-- Step 1 -->
        <div v-if="currentStep === 1" class="flex flex-col gap-2">
          <p>Step 1</p>
          <div class="">

            <label for="category" class="flex gap-2 items-center">
              <div class="flex items-center gap-2 relative py-2">
                Category
                
                <span class="text-red-400 flex items-center gap-2"
                  >*
                  <img
                    src="@/assets/exclamationMark.svg"
                    alt=""
                    srcset=""
                    class="w-4 h-4 tooltip-trigger"
                  />
                  <span
                    class="tooltip-content absolute bg-gray-700 text-white text-xs rounded py-1 px-2"
                  >
                    Please select a category.
                  </span>
                </span>


              </div>
            </label>

            <select
              name="category"
              v-model="form.category"
              required
              class="p-2 block w-full rounded-md text-sm"
              id="category"
            >
              <option value="" selected disabled>Select Category</option>
              <option
                v-for="category in categoryData"
                :key="category.id"
                :value="category.id"
              >
                {{ category.title }}
              </option>
            </select>
          </div>
          <!-- <div class="">
            <label for="batch">
              Batch<span class="text-red-400">*</span>
            </label>
            <input
              v-model="form.batch"
              required
              id="batch"
              type="number"
              placeholder="Ex.batch"
              class="border border-gray-300 rounded-md text-sm w-full p-2"
            />
          </div> -->
          <div class="">
            <label for="code" class="flex items-center gap-2 relative py-2">
              Code<span class="text-red-400 flex items-center gap-2"
                >*
                <img
                  src="@/assets/exclamationMark.svg"
                  alt=""
                  srcset=""
                  class="w-4 h-4 tooltip-trigger"
                />
                <span
                  class="tooltip-content absolute bg-gray-700 text-white text-xs rounded py-1 px-2"
                >
                  Please select a code.
                </span></span
              >
            </label>
            <input
              v-model="form.code"
              required
              id="code"
              type="text"
              placeholder="Ex.code (MCA2024JUL)"
              class="border border-gray-300 rounded-md text-sm w-full p-2 uppercase"
            />
          </div>
          <div class="flex justify-end">
            <button class="bg-[#0f172a] text-white text-xs rounded-lg px-4 py-2 mt-4" @click="nextPage">Next</button>
          </div>
        </div>

        <!-- Step 2 -->
        <div v-if="currentStep === 2" class="flex flex-col gap-2">
          <p>Step 2</p>
          <div >
            <label for="domain" class="flex items-center gap-2 relative py-2"
              >Domain<span class="text-red-400 flex items-center gap-2"
                >*
                <img
                  src="@/assets/exclamationMark.svg"
                  alt=""
                  srcset=""
                  class="w-4 h-4 tooltip-trigger"
                />
                <span
                  class="tooltip-content absolute bg-gray-700 text-white text-xs rounded py-1 px-2"
                >
                  Please select a deomain.
                </span></span
              ></label
            >
            <input
              v-model="form.domain"
              required
              id="domain"
              type="text"
              placeholder="Ex.domain (Maths, Physics, etc ..)"
              class="border border-gray-300 rounded-md text-sm w-full p-2"
            />
          </div>
          <div>
            <label for="title" class="flex items-center gap-2 relative py-2"
              >Title<span class="text-red-400 flex items-center gap-2"
                >*
                <img
                  src="@/assets/exclamationMark.svg"
                  alt=""
                  srcset=""
                  class="w-4 h-4 tooltip-trigger"
                />
                <span
                  class="tooltip-content absolute bg-gray-700 text-white text-xs rounded py-1 px-2"
                >
                  Please select a course title.
                </span></span
              ></label
            >
            <input
              v-model="form.title"
              required
              id="title"
              type="text"
              placeholder="Course Title"
              class="border border-gray-300 rounded-md text-sm w-full p-2"
            />
          </div>
          <div class="flex justify-between">
            <button type="button" class="bg-[#0f172a] text-white text-xs rounded-lg px-4 py-2 mt-4" @click="prevPage">
              Previous
            </button>
            <button type="button" class="bg-[#0f172a] text-white text-xs rounded-lg px-4 py-2 mt-4" @click="nextPage">
              Next
            </button>
          </div>
        </div>

        <!-- Step 3 -->
        <div v-if="currentStep === 3" class="flex flex-col gap-2">
          <p>Step 3</p>
          <div>
            <label class="flex items-center gap-2 relative py-2" for="units" 
              >Unit title<span class="text-red-400 flex items-center gap-2"
                >*<img
                  src="@/assets/exclamationMark.svg"
                  alt=""
                  srcset=""
                  class="w-4 h-4 tooltip-trigger"
                />
                <span
                  class="tooltip-content absolute bg-gray-700 text-white text-xs rounded py-1 px-2"
                >
                  Please select a Unit title.
                </span></span
              ></label
            >
            <input
              v-model="form.unit_title"
              required
              id="unit title"
              type="text"
              placeholder="Ex.unit title"
              class="border border-gray-300 rounded-md text-sm w-full p-2"
            />
          </div>
          <div>
            <label class="flex items-center gap-2 relative py-2" for="units"
              >Unit name<span class="text-red-400 flex items-center gap-2"
                >*
                <img
                  src="@/assets/exclamationMark.svg"
                  alt=""
                  srcset=""
                  class="w-4 h-4 tooltip-trigger"
                />
                <span
                  class="tooltip-content absolute bg-gray-700 text-white text-xs rounded py-1 px-2"
                >
                  Please select a Unit name.
                </span>
              </span></label
            >
            <input
              v-model="form.unit_unit"
              required
              id="units"
              type="text"
              placeholder="Ex.units"
              class="border border-gray-300 rounded-md text-sm w-full p-2"
            />
          </div>
          <div>
            <label class="flex items-center gap-2 relative py-2" for="size"
              >Unit size<span class="text-red-400 flex items-center gap-2"
                >*
                <img
                  src="@/assets/exclamationMark.svg"
                  alt=""
                  srcset=""
                  class="w-4 h-4 tooltip-trigger"
                />
                <span
                  class="tooltip-content absolute bg-gray-700 text-white text-xs rounded py-1 px-2"
                >
                  Please select a Unit size.
                </span></span
              ></label
            >
            <input
              v-model="form.unit_size"
              required
              id="size"
              type="number"
              placeholder="Ex.unit size"
              class="border border-gray-300 rounded-md text-sm w-full p-2"
            />
          </div>

          <div>
            <label class="flex items-center gap-2 relative py-2" for="unit_instruction"
              >Unit instruction promt<span class="text-red-400 flex items-center gap-2"
                >*
                <img
                  src="@/assets/exclamationMark.svg"
                  alt=""
                  srcset=""
                  class="w-4 h-4 tooltip-trigger"
                />
                <span
                  class="tooltip-content absolute bg-gray-700 text-white text-xs rounded py-1 px-2"
                >
                  Please select a Unit instruction promt.
                </span></span
              ></label
            >

            <textarea
              name=""
              v-model="form.unit_instruction"
              required
              id=""
              cols="20"
              rows="1"
              placeholder="Ex.instruction promt"
              class="border border-gray-300 rounded-md text-sm w-full p-2"
            >
            </textarea>
          </div>

          <div class="flex justify-start items-center gap-2">
            <label for="freeCourse">Assignments </label>
            <input
              id="Assessments"
              type="checkbox"
              class=""
              v-model="form.Assignment"
              required
              @change="toggleSub"
            />
          </div>

          <div v-if="isAssessmentsActive">
            <label class="flex items-center gap-2 relative py-2" for="assessmentDetails">
              Number of assignments
              <span class="text-red-400 flex items-center gap-2"
                >*
                <img
                  src="@/assets/exclamationMark.svg"
                  alt=""
                  srcset=""
                  class="w-4 h-4 tooltip-trigger"
                />
                <span
                  class="tooltip-content absolute bg-gray-700 text-white text-xs rounded py-1 px-2"
                >
                  Please select a Number of assignment.
                </span></span
              ></label
            >
            <input
              v-model="form.Assignment_size"
              required
              id="AssignData"
              type="number"
              class="border border-gray-300 rounded-md text-sm w-full p-2"
              placeholder="Ex.number of assignments"
            />
          </div>

          <div class="flex justify-start items-center gap-2">
            <label for="freeCourse">Quizs </label>
            <input
              id="Quizs"
              type="checkbox"
              class=""
              v-model="form.quiz_size"
              required
              @change="toggleSubquiz"
            />
          </div>

          <div v-if="isQuizActive">
            <label class="flex items-center gap-2 relative py-2" for="quizDetails"
              >Number of quizs
              <span class="text-red-400 flex items-center gap-2"
                >*
                <img
                  src="@/assets/exclamationMark.svg"
                  alt=""
                  srcset=""
                  class="w-4 h-4 tooltip-trigger"
                />
                <span
                  class="tooltip-content absolute bg-gray-700 text-white text-xs rounded py-1 px-2"
                >
                  Please select a Number of quizs.
                </span></span
              ></label
            >
            <input
              v-model="form.QuizData"
              required
              id="QuizData"
              type="number"
              class="border border-gray-300 rounded-md text-sm w-full p-2"
              placeholder="Ex.number of quizs"
            />
          </div>

          <div>
            <label class="flex items-center gap-2 relative py-2" for="instruction"
              >Course Instruction promt<span class="text-red-400 flex items-center gap-2"
                >*
                <img
                  src="@/assets/exclamationMark.svg"
                  alt=""
                  srcset=""
                  class="w-4 h-4 tooltip-trigger"
                />
                <span
                  class="tooltip-content absolute bg-gray-700 text-white text-xs rounded py-1 px-2"
                >
                  Please select a Unit course instruction promt.
                </span></span
              ></label
            >

            <textarea
              name=""
              v-model="form.instruction"
              required
              id=""
              cols="20"
              rows="5"
              placeholder="Ex.course instruction"
              class="border border-gray-300 rounded-md text-sm w-full p-2"
            >
            </textarea>
          </div>
          <div class="flex justify-between">
            <button type="button" class="bg-[#0f172a] text-white text-xs rounded-lg px-4 py-2 mt-4" @click="prevPage">
              Previous
            </button>
            <button type="submit" class="bg-[#0f172a] text-white text-xs rounded-lg px-4 py-2 mt-4">Save</button>
          </div> 
            <!-- <h2 class="p-4 text-lg font-semibold text-green-400" v-if="loading">
              Parameters Submitted successfully !
            </h2> -->
        </div>
      </form>
    </div>


    

        <div v-if="loading"
            class="fixed top-0 left-0 z-50 bg-black bg-opacity-60 h-screen w-full flex items-center">
            <div class="relative w-auto mx-auto rounded-lg bg-white p-4 lg:p-6 text-gray-700 text-center shadow-xl">
              
                <!-- <h2 v-if="regenerate_status" class="p-4 text-lg font-semibold capitalize">{{ regenerate_message }}</h2> -->
                <!-- <h2 v-else class="p-4 text-lg font-semibold capitalize">Course Prompt Regenerating</h2> -->
                
                <div v-if="loading" class="flex flex-col justify-center items-center">
                    <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    Course prompt generating...
                </div>

                <!-- <button v-if="regenerate_status" type="submit" class="gradient-btn mt-4"
                    @click="popup_regenerate = false">
                    Close
                </button> -->


            </div>
        </div>



  </div>
</template>

<script>

import Header from "@/components/Admin/Header.vue";

import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "NewCourse",
  data() {
    return {
      currentStep: 1,
      form: {
        category: "",
        // batch: "",
        code: "",
        domain: "",
        title: "",
        unit_unit: "",
        unit_title: "",
        unit_instruction: "",
        unit_size: "",
        instruction: "",
        Assignment: "",
        quiz: "",
        Assignment_size: "",
        quiz_size: "",
        batch:1
      },
      isAssessmentsActive: false,
      isQuizActive: false,
      categoryData: [],
      loading: false,
    };
  },

  components: {
    Header
  },

  async created() {
    await this.fetchcategory();
  },

  computed: {
    ...mapGetters(["userInfo"]),
    progressBarWidth() {
      return `${(this.currentStep / 3) * 100}%`;
    },
  },

  methods: {
    nextPage() {
      const isValid = this.validateCurrentStep();
      if (isValid) {
        this.currentStep++;
      }
    },
    validateCurrentStep() {
      // Basic validation for the current step
      const fields = {
        1: ["category", "code"],
        2: ["domain", "title"],
        3: ["units", "size", "Assessments", "Quiz", "instruction"],
      };
      return fields[this.currentStep].every((field) => this.form[field]);
    },
    prevPage() {
      this.currentStep--;
    },

    toggleSub(event) {
      this.isAssessmentsActive = !this.isAssessmentsActive;
    },
    toggleSubquiz() {
      this.isQuizActive = !this.isQuizActive;
    },

    async generate(gemini_id) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/gemini/post/${gemini_id}/?Key=${this.userInfo.token_key}`
        )
        .then((resp) => {
          console.log("response", resp);
          if (resp.status === 200) {
            this.genaraic = resp.data;
            setTimeout(()=>{
              this.loading = false;
               this.$router.push({
                name: "PromptList",
              });
            },3000)
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },

    NewCourse() { 
        this.loading = true;
        axios
            .post(
            `${process.env.VUE_APP_API}/coursepromptnew/?Key=${this.userInfo.token_key}`,
            this.form
            )

            .then((response) => {
            if (response.data.status == 200) {
                this.newcourseid = response.data.data;
                this.generate(response.data.data.id);
                // this.$router.push({name: 'AiCourseCreatePrompt'});
              //    this.$router.push({
              //   name: "PromptList",
              // });
            }
            })
            .catch((err) => {
            console.log("error", err);
            });

    },

    async fetchcategory() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/category/`
        );
        this.categoryData = response.data.data;
        console.log("categoryData", this.categoryData);
      } catch (error) {
        console.error("Error fetching categoryData:", error);
      }
    },
  },
};
</script>

<style>
.tooltip-content {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.2s ease;
  position: absolute;
  bottom: -90%; /* Tooltip appears above the icon */
  left: 100px;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 5px 10px;
  border-radius: 4px;
  z-index: 100;
  white-space: nowrap;
}

.tooltip-trigger {
  position: relative;
}

.tooltip-trigger:hover + .tooltip-content,
.tooltip-trigger:focus + .tooltip-content {
  visibility: visible;
  opacity: 1;
} 


.lds-ring,
.lds-ring div {
    box-sizing: border-box;
}

.lds-ring {
    display: inline-block;
    position: relative;
    width: 60px;
    height: 60px;
    color: #18469d;
}

.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 44px;
    height: 44px;
    margin: 4px;
    border: 4px solid currentColor;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: currentColor transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}

@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

</style>
